import { breakpoints } from "@config/theme"
import styled from "styled-components"
import * as S from "../elements"

const size = {
  small: "50%",
  medium: "75%",
  large: "90%",
}

export const ProductImage = styled(S.BaseImage)<{ imageSize: string }>`
  transition: all 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  transform-origin: center;
  max-height: 80%;
  width: ${(p) => size[p.imageSize]};
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;

  @media screen and (max-width: ${breakpoints.medium}) {
    height: 80%;
    max-height: 100%;
  }
`

export const HoverImage = styled(S.BaseImage)`
  opacity: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  top: 0;
  transform: scale(0.95);
`
